import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="py-12 border-t border-white/10 transition-colors duration-300 bg-[#000000]" data-id="element-383">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-384">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-385">
          <div className="md:col-span-2" data-id="element-386">
            <Link to="/" data-id="element-387">
              <img src="https://cdn.magicpatterns.com/uploads/kJHhLj6UwPq3LR5JrpxsMh/NEW_GRAVEL_LOGO.png" alt="253Gravel" className="h-10 w-auto mb-4" style={{
              filter: 'brightness(0) saturate(100%) invert(40%) sepia(60%) saturate(500%) hue-rotate(100deg) brightness(95%) contrast(90%)'
            }} data-id="element-388" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-389">
              Premium gravel, crushed rock, and aggregate delivery serving
              Tacoma and South King County. Fast, reliable, and transparent.
            </p>
          </div>

          <div data-id="element-390">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-391">
              Contact
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-392">
              <li data-id="element-393">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-394">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-395">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-396">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-397">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-398">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-399">
              Hours
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-400">
              <li className="flex justify-between" data-id="element-401">
                <span data-id="element-402">Mon-Fri:</span>
                <span data-id="element-403">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-404">
                <span data-id="element-405">Saturday:</span>
                <span data-id="element-406">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-407">
                <span data-id="element-408">Sunday:</span>
                <span data-id="element-409">Closed</span>
              </li>
            </ul>
          </div>

          <div data-id="element-410">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-411">
              Service Areas
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-412">
              <li data-id="element-413">Tacoma</li>
              <li data-id="element-414">Puyallup</li>
              <li data-id="element-415">Federal Way</li>
              <li data-id="element-416">Auburn</li>
              <li data-id="element-417">Kent</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-418">
          <p data-id="element-419">
            &copy; {new Date().getFullYear()} 253Gravel. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-420">
            <a href="#" className="hover:text-white transition-colors" data-id="element-421">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-422">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}